import React from 'react';
import { Link } from "react-router-dom";
import { Hexagon } from 'react-feather';
import { useLocalizedData } from '../hooks/useTranslatedContent';

export default function OurServices({ homePageData }) {
    const { getLocalized } = useLocalizedData(homePageData);

    const servicesTitle = getLocalized('servicesTitle');
    const servicesSubTitle = getLocalized('servicesSubTitle');

    const services = getLocalized('servicesHome', true) || [];

    if (!services || services.length === 0) {
        return null;
    }

    return (
        <section className="relative md:py-24 py-16" id="features">
            <div className="absolute inset-0 bg-black/10 pointer-events-none z-0"></div>
            <div className="container relative z-10 mx-auto">
                <div className="grid grid-cols-1 pb-8 text-center">
                    <h3 className="mb-4 md:text-2xl text-xl font-medium text-slate-600">
                        {servicesTitle || "Our Services"}
                    </h3>
                    <p className="text-slate-400 max-w-xl mx-auto">
                        {servicesSubTitle || "We provide the best services for your business"}
                    </p>
                </div>

                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className="group relative lg:px-6 mt-4 transition duration-500 ease-in-out rounded-xl overflow-hidden text-center bg-white/10 backdrop-blur-md p-6 hover:shadow-lg"
                        >
                            <div className="relative overflow-hidden text-transparent -m-3">
                                <Hexagon className="h-28 w-28 fill-slate-950/10 mx-auto rotate-[30deg]" />
                                <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto rounded-xl transition duration-500 ease-in-out flex align-middle justify-center items-center">
                                    {service.img && (
                                        <img
                                            src={service.img || '/default-service-icon.png'}
                                            alt={''}
                                            style={{ width: '50px', height: '50px', objectFit: 'contain' }}
                                        />
                                    )}

                                </div>
                            </div>
                            <div className="mt-6">
                                <Link
                                    to="/services"
                                    className="text-lg h5 transition duration-500 ease-in-out text-black-600 hover:text-black"
                                >
                                    {service.title || "Service"}
                                </Link>
                                <p
                                    className="text-slate-800 transition duration-500 ease-in-out mt-3"
                                    dangerouslySetInnerHTML={{
                                        __html: service.description || "Service description"
                                    }}
                                ></p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}